import type { ErrorResponse } from "@core/types/errorResponse";

/** Refetch assigned rows after remove succeeded, then always surface the assign error. */
export async function handleAssignFailureAfterPartialRemove(
  removeSucceededThisSave: boolean,
  reloadAssignedFromServer: () => Promise<void>,
  assignError: ErrorResponse,
  showError: (error: ErrorResponse) => void
): Promise<void> {
  try {
    if (removeSucceededThisSave) {
      await reloadAssignedFromServer();
    }
  } catch {
    // List may stay stale; assign error still shown below.
  } finally {
    showError(assignError);
  }
}
